/**
 *
 *  a dedicated class for doing positioning
 * @param {*} configurations
 * @param {*} context optional document object to cater parent and iframe based DOM manipulation alike
 * @returns
 */
import ChatMode from '../hooks/ChatMode';
import getViewport from '../hooks/getViewport';
import { Position, SkinInviteType } from '../enums/Enum';
import Positioner from './Positioner';
import showElement from '../hooks/showElement';
import addClass from '../hooks/addClass';
import loadJQuery from '../hooks/loadJQuery';

export default class DOMPositioner extends Positioner {
    constructor(configurations, context) {
        super(configurations, context);
        const me = this;
        me.configuration = configurations;
        me.DOM = context || document;
    }

    position(options) {
        const me = this;
        const tempDOM = me.DOM;
        if (options.context) {
            me.DOM = options.context;
        }
        if (options.isScroll) {
            return;
        }
        const objName = options.element;
        let targetObj;
        if (typeof objName === 'object') {
            targetObj = objName;
        } else {
            const pureElement = this.getPureElement(objName);
            targetObj = this.getElement(objName, pureElement);
            if (targetObj === null) {
                targetObj = document.getElementById(objName);
            }
        }
        let padding = 7;
        const container = targetObj;
        const dims = getViewport();
        /// For Android Glaxy tablets isMobile flag is not working thats why we add the android user agent condition
        if (options.model.options.isMobile || /Android/i.test(navigator.userAgent)) {
            loadJQuery().then(_ => {
                const diff =
                    ApexChat.ApexChatJquery(window).height() -
                    ApexChat.ApexChatJquery(container).height();
                const current = ApexChat.ApexChatJquery(container, this.DOM).height();
                let target = current + diff;
                if (target < 110) {
                    target = 110; // cutoff
                }
                let className = 'apexchat_dompopup_chatwindow_wrapper_mobile_width';
                if (ApexChat.options.skinInviteType === SkinInviteType.Rounded_Dynamic) {
                    className = 'apexchat_rd_dompopup_chatwindow_wrapper_mobile_width';
                    target = dims[1];
                }
                ApexChat.ApexChatJquery(container, this.DOM).css({ height: `${target}px` });
                if (!ApexChat.ApexChatJquery(container, this.DOM).hasClass(className)) {
                    addClass(ApexChat.ApexChatJquery(container, this.DOM)[0], className);
                }
                if (!ApexChat.originalDeviceHeight) {
                    ApexChat.originalDeviceHeight = target; // set height of screen only first time
                }
                ApexChat.deviceHeight = target;
                if (
                    /iPad|iPhone|iPod/.test(navigator.userAgent) &&
                    !window.MSStream &&
                    options.model.options.chatMode == ChatMode.DOM
                ) {
                    const lastHeight = ApexChat.ApexChatJquery(window).height(); //  store the intial height.
                    const lastWidth = ApexChat.ApexChatJquery(window).width(); //  store the intial width.
                    const keyboardIsOn = false;
                    if (ApexChat.ApexChatJquery('#apexchat_chatMsg_textbox', this.DOM).is(':focus')) {
                        ApexChat.ApexChatJquery('.livechat_messages', this.DOM).css({
                            height: `${lastHeight / 3.5}px`
                        });
                    } else {
                        ApexChat.ApexChatJquery('.livechat_messages', this.DOM).css({
                            height: `${target}px`
                        });
                    }
                }
            });
        } else {
            try {
                loadJQuery().then(_ => {
                    // support for padding in FF, etc
                    const el = ApexChat.ApexChatJquery(container, this.DOM);
                    const shadow =
                        el.css('-moz-box-shadow') + el.css('-webkit-box-shadow') + el.css('box-shadow');
                    if (shadow) {
                        let parts = shadow.split(' ');
                        parts = parts.slice(parts.length - 4);
                        padding = 0;
                        for (let i = 0; i < parts.length; i++) {
                            const x = parseInt(parts[i], 10);
                            if (!isNaN(x)) {
                                padding += x;
                            }
                        }
                    }
                });
            } catch (e) { }
            if (options.model.options.position === Position.Center) {
                options.model.options.position = Position.Right;
            }
            container.style.position = 'fixed';
            // CHAT-5085 the Iframe size is increasing in case of long content(header disclaimer) but content is making scroll to be appeared as required.
            if (options.model.computedHeight && options.model.computedHeight < 500) {
                container.firstChild.style.height = `${options.model.computedHeight}px`;
            } else {
                container.firstChild.style.height = '500px'; // If Size is increasing more than 580 than put 580 as max-size.
                if (
                    options.model.options.videoGreet &&
                    options.model.options.videoGreet.persistVideoRatioForWidget
                ) {
                    container.firstChild.style.width = `${ApexChat.WidgetMaximizedWidth + 32}px`;
                    const triggerWidgetResize = function () {
                        const winHeight = window.innerHeight;
                        const widgetHeight = ApexChat.WidgetMaximizedHeight;
                        container.firstChild.style.height =
                            winHeight < widgetHeight ? `${winHeight - 20}px` : `${widgetHeight}px`;
                    };
                    triggerWidgetResize();
                    window.addEventListener(
                        'resize',
                        (event) => {
                            triggerWidgetResize();
                        },
                        true
                    );
                }
            }
            switch (options.model.options.position) {
                case Position.Right:
                    container.style.bottom = '10px';
                    container.style.right = '0px';
                    break;
                case Position.Left:
                    container.style.bottom = '10px';
                    container.style.left = '0px';
                    break;
                case Position.Middle:
                    container.style.bottom = '10px';
                    container.style.left = `${dims[0] / 2 - container.offsetWidth / 2}px`;
                    break;
                case Position.TopRight:
                    container.style.top = '0px';
                    container.style.right = '0px';
                    break;
                case Position.TopLeft:
                    container.style.top = '0px';
                    container.style.left = '0px';
                    break;
                case Position.TopMiddle:
                    container.style.top = '0px';
                    container.style.left = `${dims[0] / 2 - container.offsetWidth / 2}px`;
                    break;
                case Position.LeftCenter:
                    container.style.top = `${dims[1] / 4 - 0}px`;
                    container.style.left = '0px';
                    break;
                case Position.RightCenter:
                    container.style.top = `${dims[1] / 4 - 0}px`;
                    container.style.right = '0px';
                    break;
                default:
            }
        }
        me.DOM = tempDOM;
        showElement(me.DOM.querySelector('#apexchat_dompopup_chatwindow_max'));
        me.DOM.querySelector('#apexchat_dompopup_chatwindow_max')?.style.visibility = 'visible';
    }
}
